"use strict";

/**
* Прикладные методы объектов.
* 
* @namespace WebAccess.domainMethods
* @comment от какого класса наследуется класс domainMethods? и почему файл называется EntityMethods, а не domainMethods.js?
*/

(function (global) {
  /**
   * Вызывает прикладной метод.
   *
   * @function WA.domainMethods.executeEntityMethod
   * @comment почему функция, а не метод?
   * @param {string} service Путь до папки сервиса. 
   * @param {number} entityId ИД объекта, для которого вызызвается метод.
   * @param {string} methodName Имя метода. 
   * @param {Array<Object>} parameters Параметры, с которыми вызызвается метод.
   * @return {Deferred<Object>} Результат выполнения прикладного метода.
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.executeEntityMethod = function (service, entityId, viewName, methodName, parameters) {
    var factory = global.variantParameterFactory;
    var variantParameters = parameters.map(function (parameter) {
      if (parameter instanceof global.VariantParameter) {
        return parameter;
      } else {
        return factory.сreateVariantParameter(parameter);
      }
    });

    var d = $.Deferred();

    //для записи справочника обязательно надо отправить ссылку, так как для несохраненной записи обязательно нужен код справочника
    //а для диалога нельзя отправить ссылку, так как для диалога отправляется InstanceId 
    WA.SRV.call(service, {
      "entityLink": entityId instanceof WA.Link ? entityId.toLinkModel() : null,
      "entityId": entityId instanceof WA.Link ? entityId.id : entityId,
      "methodName": methodName,
      "methodParameters": variantParameters,
      "viewName": viewName || ""
    }).done(function (res) {
      //спец обработка для дат, так как они приходят в формате "/Date(-1797825600000)/"
      res.MethodResult = parseMethodResult(res.MethodResult);

      d.resolve(res);
    }).fail(function (message, res) {
      d.reject(message, res);
    });

    return d.promise();
  }

  /**
   * Проверяет, доступнен ли метод для текущего объекта.
   *
   * @function WA.domainMethods.isMethodAvailable
   * @comment почему функция, а не метод?
   * @param {string} service Путь до папки сервиса. 
   * @param {number} entityId ИД объекта, для которого вызывается метод.
   * @param {string} methodName Имя метода.
   * @return {Deferred<boolean>} True – прикладной метод доступен для текущего объекта, иначе False.
   * @since 5.5.0.1000
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.isMethodAvailable = function (service, entityId, methodName) {
    var d = $.Deferred();

    //для записи справочника обязательно надо отправить ссылку, так как для несохраненной записи обязательно нужен код справочника
    //а для диалога нельзя отправить ссылку, так как для диалога отправляется InstanceId 
    WA.SRV.call(service, {
      "entityLink": entityId instanceof WA.Link ? entityId.toLinkModel() : null,
      "entityId": entityId instanceof WA.Link ? entityId.id : entityId,
      "methodName": methodName
    }).done(function (res) {
      d.resolve(res);
    }).fail(function (res) {
      d.reject(res);
    });

    return d.promise();
  }

  /**
   * Проверяет, является ли объект данных ссылкой на модель.
   * @function WA.domainMethods.isLinkModel
   * @param {object} obj Проверяемый объект. 
   * @return {boolean} True – проверяемый объект данных является ссылкой на модель, иначе False. 
   */
  function isLinkModel(obj) {
    return (typeof obj === "object" && obj.__type && obj.__type === "NpoComputer.WebAccess.Models.Link");
  }

  /**
   * Проверяет, является ли объект данных списком ссылок на модель.
   * @function WA.domainMethods.isLinkModelArray
   * @param {object} obj Проверяемый объект. 
   * @return {boolean} True – проверяемый объект данных является списком ссылок на модель, иначе False. 
   */
  function isLinkModelArray(obj) {
    return (obj instanceof Array && obj[0] && isLinkModel(obj[0]));
  }

  /**
 * Проверяет, является ли объект данных датой.
 * @function WA.domainMethods.isDate
 * @param {object} obj Проверяемый объект. 
 * @return {boolean} True – проверяемый объект данных является датой, иначе False. 
 */
  function isDate(obj) {
    return (typeof obj === "string" && obj.indexOf("/Date") === 0);
  }

  /**
   * Проверяет, является ли объект данных списком дат.
   * @function WA.domainMethods.isDateArray
   * @param {object} obj Проверяемый объект. 
   * @return {boolean} True – проверяемый объект данных является списком дат, иначе False.
   */
  function isDateArray(obj) {
    return (obj instanceof Array && obj[0] && isDate(obj[0]));
  }

  /**
   * Заменяет объекты-модели на обычные объекты в результате прикладного метода.
   * @function WA.domainMethods.parseMethodResult
   * @param {object} methodResult Результат выполнения прикладного метода c объектами-моделями. 
   * @return {object} Результат выполнения прикладного метода c обычными объектами. 
   */
  function parseMethodResult(methodResult) {

    if (methodResult != null) {
      if (isLinkModel(methodResult)) {
        return (new WA.Link()).fromLinkModel(methodResult);
      } else if (isLinkModelArray(methodResult)) {
        var linkArray = methodResult.map(function (item) {
          return (new WA.Link()).fromLinkModel(item);
        });
        return linkArray;
      }

      if (isDate(methodResult)) {
        return parseDate(methodResult);
      } else if (isDateArray(methodResult)) {
        var dateArray = methodResult.map(function (item) {
          return parseDate(item);
        });
        return dateArray;
      }
    }

    return methodResult;
  }

})(window.WebAccess.domainMethods);